/**
 * Centralized site configuration for structured data (JSON-LD) and SEO.
 * Single source of truth for organization details used across schema generators.
 *
 * Brand assets: use SITE_*_PATH in HTML (relative), SITE_*_URL in meta/JSON-LD (absolute).
 * Next serves files from apps/client/public/ at SITE_*_PATH; nginx mirrors the same paths
 * (location = /og-image.png, /logo.png, /favicon.ico) so dev/prod match behind reverse proxy.
 */

export const SITE_NAME = 'RatesAgent.AI';
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://ratesagent.ai/';
/** Origin only (no trailing slash). Use for absolute asset URLs. */
export const SITE_ORIGIN = SITE_URL.replace(/\/+$/, '');

/** Root-relative URL paths; basename must match a file in apps/client/public/. */
export const SITE_FAVICON_PATH = '/favicon.ico';
/** Vector mark — prefer for tab icons where supported (also in public/). */
export const SITE_ICON_SVG_PATH = '/icon.svg';
export const SITE_LOGO_PATH = '/logo.png';
export const SITE_OG_IMAGE_PATH = '/og-image.png';

/** Absolute URLs for Open Graph, Twitter, JSON-LD, and explicit meta tags. */
export const SITE_FAVICON_URL = `${SITE_ORIGIN}${SITE_FAVICON_PATH}`;
export const SITE_ICON_SVG_URL = `${SITE_ORIGIN}${SITE_ICON_SVG_PATH}`;
export const SITE_LOGO_URL = `${SITE_ORIGIN}${SITE_LOGO_PATH}`;
export const SITE_OG_IMAGE_URL = `${SITE_ORIGIN}${SITE_OG_IMAGE_PATH}`;

export const SITE_DESCRIPTION = 'AI agent that connects shippers with logistics providers for container shipping worldwide';

export const ADDRESS = {
  streetAddress: 'Vesivarava tn 50-201',
  addressLocality: 'Tallinn',
  postalCode: '10152',
  addressCountry: 'EE',
};

export const CONTACT_EMAIL = 'contact@ratesagent.ai';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/ratesagentai/';
